<template>
  <v-card class="emp-details">
    <v-card-title>
      <img :src="empAttend.img || require('@/assets/imgs/no-img21.png')" />
      <v-row class="flex-column ml-3">
        <span class="headline-1">{{ empAttend.name }}</span>
        <span class="headline-2">{{ empAttend.department }}</span>
        <span class="headline-3">{{ empAttend.post }}</span>
      </v-row>
    </v-card-title>
    <v-card-text class="pb-0">
      <v-row>
        <v-col cols="6" v-if="empAttend.salaryNomina">Salario Nomina:
          {{ formatMoney(empAttend.salaryNomina) }}</v-col>
        <v-col cols="6" v-if="empAttend.salaryAyco">Salario Ayco:
          {{ formatMoney(empAttend.salaryAyco) }}</v-col>
      </v-row>
      <v-calendar event-more type="month" :start="formatTime(dates.fromDate)" :end="formatTime(dates.toDate)"
        :events="events" locale="es-GU" :event-color="(ev) => ev.color" :event-height="24">
        <template v-slot:event="{ event }">
          <v-icon v-if="event.color === 'green'">check_circle</v-icon>
          <v-icon v-else>clear</v-icon>
        </template>
      </v-calendar>
    </v-card-text>

    <v-card-actions class="pt-0">
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="onClose">Salir</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formatMoney } from '@/services/utils'
import { toUTC, getDaysInMonth, UTCReady } from '../services/timeUtils';
import { padNum } from '../services/utils';
export default {
  props: {
    empAttend: Object,
    dates: Object
  },
  created() {
    this.formatMoney = formatMoney
  },
  computed: {
    events() {
      const eventMap = this.getEmptyEventMap()
      this.empAttend.days.forEach((day) => {
        const currDay = day.substr(8, 2)
        eventMap[currDay].color = 'green'
      })
      return Object.values(eventMap)
    },

  },
  methods: {
    onClose() {
      this.$router.push('./')
    },
    onCreateReport() {
      this.$router.push(`edit/${this.emp._id}`)
    },
    formatTime(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    getEmptyEventMap() {
      const events = new Array(getDaysInMonth(this.dates.fromDate)).fill(false)
      const date = new Date(this.dates.fromDate)
      return events.reduce((acc, event, idx) => {
        acc[padNum(date.getDate())] = { color: 'red', start: UTCReady(date).toISOString().substr(0, 10) }
        date.setDate(date.getDate() + 1)
        return acc
      }, {})
    }
  }
}
</script>

<style lang="scss">
.v-calendar-weekly__day {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.v-event {
  display: flex;
  justify-content: center;
}
</style>